import { render, staticRenderFns } from "./app_list.vue?vue&type=template&id=59de7820&scoped=true&"
import script from "./app_list.vue?vue&type=script&lang=js&"
export * from "./app_list.vue?vue&type=script&lang=js&"
import style0 from "./app_list.vue?vue&type=style&index=0&id=59de7820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59de7820",
  null
  
)

export default component.exports